import type { IMasterDataProductUomRepository } from "@src/domain/repositories/masterData";
import type { CreateMasterDataProductUomDTO } from "@src/domain/dto/masterData";

export class CreateMasterDataProductUomUseCase {
  private readonly repository: IMasterDataProductUomRepository;

  constructor(repository: IMasterDataProductUomRepository) {
    this.repository = repository;
  }

  execute(params: CreateMasterDataProductUomDTO) {
    return this.repository.createProductUom(params);
  }
}
